import { render, staticRenderFns } from "./Ignore.vue?vue&type=template&id=222eec56"
import script from "./Ignore.vue?vue&type=script&lang=js"
export * from "./Ignore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports